<mat-form-field appearance="outline" class="full-width">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    [formControl]="recipientControl"
    [placeholder]="placeholder"
    [matAutocomplete]="auto"
    (input)="onInputChange($any($event.target).value)"
    (keydown)="handleMenuKeydown($event)">
  <mat-autocomplete #auto="matAutocomplete" 
    [displayWith]="displayFn"
    (optionSelected)="onOptionSelected($event.option.value)">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
      <div class="recipient-option">
        <div class="recipient-name">{{ option.displayName }}</div>
        <div class="recipient-email">{{ option.email }}</div>
      </div>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
